import { authClient, API } from '../index'

// Get all technologies
export const getAllActiveBusinessAreas = () => {
    return authClient().get(`${API}/businessArea/`)
}

export const getAllBusinessAreas = () => {
    return authClient().get(`${API}/businessArea/?getDisabled=true`)
}

// Get businessArea by id
export const getBusinessAreaById = (id) => {
    return authClient().get(`${API}/businessArea/${id}`)
}

// Create businessArea
export const postBusinessArea = async (businessArea) => {
    return authClient().post(`${API}/businessArea/`, businessArea)
}

// Update text
export const updateBusinessArea = (id, businessArea) => {
    return authClient().put(`${API}/businessArea/${id}`, businessArea)
}

// Change status businessArea
export const changeStatusBusinessArea = async (id, active) => {
    return authClient().put(`${API}/businessArea/change-status/${id}`, { active });
};


// Delete businessArea
export const deleteBusinessArea = (id) => {
    return authClient().delete(`${API}/businessArea/${id}`)
}
